const URL_LONG = /^(((http[s]?)|file):)?(\/\/)+([0-9a-zA-Z-_.=?&].+)$/;
const URL_SHORT = /^((\.|\.\.)?\/)([0-9a-zA-Z-_.=?&]+\/)*([0-9a-zA-Z-_.=?&]+)$/;
const isValidURL = (str) => URL_LONG.test(str) || URL_SHORT.test(str);
export function createStyle(doc, cssText) {
  const style = doc.createElement("style");
  style.type = "text/css";
  style.appendChild(window.document.createTextNode(cssText));
  return style;
}
export function createLinkStyle(doc, url) {
  const style = doc.createElement("link");
  style.type = "text/css";
  style.rel = "stylesheet";
  style.href = url;
  return style;
}
export function createIFrame(parent) {
  const el = window.document.createElement("iframe");
  el.setAttribute("src", "about:blank");
  el.setAttribute("style", "visibility:hidden;width:0;height:0;position:absolute;z-index:-9999;bottom:0;");
  el.setAttribute("width", "0");
  el.setAttribute("height", "0");
  el.setAttribute("wmode", "opaque");
  parent.appendChild(el);
  return el;
}
const DEFAULT_OPTIONS = {
  parent: window.document.body,
  headElements: [],
  bodyElements: []
};
/** Printd class that prints HTML elements in a blank document */
export default class Printd {
  constructor(options) {
    this.isLoading = false;
    this.hasEvents = false;
    // IE 11+ "Object.assign" polyfill
    this.opts = [DEFAULT_OPTIONS, options || {}].reduce((a, b) => {
      Object.keys(b).forEach((k) => (a[k] = b[k]));
      return a;
    }, {});
    this.iframe = createIFrame(this.opts.parent);
  }
  /** Gets current Iframe reference */
  getIFrame() {
    return this.iframe;
  }

  prints(els, styles, scripts, callback) {
    if (this.isLoading)
      return;
    const { contentDocument, contentWindow } = this.iframe;
    if (!contentDocument || !contentWindow)
      return;
    this.iframe.src = "about:blank";
    // this.elCopy = el.cloneNode(true);
    this.elCopy = [...els].reduce((acc, cur) => [...acc, cur.cloneNode(true)], [])
    if (!this.elCopy)
      return;
    this.isLoading = true;
    this.callback = callback;
    const doc = contentWindow.document;
    doc.open();
    doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body style="padding: 0; margin: 0;"></body></html>');
    this.addEvents();
    // 1. append custom elements
    const { headElements, bodyElements } = this.opts;
    // 1.1 append custom head elements
    if (Array.isArray(headElements)) {
      headElements.forEach((e) => doc.head.appendChild(e));
    }
    // 1.1 append custom body elements
    if (Array.isArray(bodyElements)) {
      bodyElements.forEach((e) => doc.body.appendChild(e));
    }
    // 2. append custom styles
    if (Array.isArray(styles)) {
      styles.forEach((value) => {
        if (value) {
          doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
        }
      });
    }
    // 3. append element copy
    // doc.body.appendChild(this.elCopy);
    this.elCopy.map(e => {
      doc.body.appendChild(e)
    })
    // 4. append custom scripts
    if (Array.isArray(scripts)) {
      scripts.forEach((value) => {
        if (value) {
          const script = doc.createElement("script");
          if (isValidURL(value)) {
            script.src = value;
          }
          else {
            script.innerText = value;
          }
          doc.body.appendChild(script);
        }
      });
    }
    doc.close();
  }


  /**
   * Print an HTMLElement
   *
   * @param el HTMLElement
   * @param styles Optional styles (css texts or urls) that will add to iframe document.head
   * @param scripts Optional scripts (script texts or urls) that will add to iframe document.body
   * @param callback Optional callback that will be triggered when content is ready to print
   */
  print(el, styles, scripts, callback) {
    if (this.isLoading)
      return;
    const { contentDocument, contentWindow } = this.iframe;
    if (!contentDocument || !contentWindow)
      return;
    this.iframe.src = "about:blank";
    this.elCopy = el.cloneNode(true);
    if (!this.elCopy)
      return;
    this.isLoading = true;
    this.callback = callback;
    const doc = contentWindow.document;
    doc.open();
    doc.write('<!DOCTYPE html><html><head><meta charset="utf-8"></head><body></body></html>');
    this.addEvents();
    // 1. append custom elements
    const { headElements, bodyElements } = this.opts;
    // 1.1 append custom head elements
    if (Array.isArray(headElements)) {
      headElements.forEach((e) => doc.head.appendChild(e));
    }
    // 1.1 append custom body elements
    if (Array.isArray(bodyElements)) {
      bodyElements.forEach((e) => doc.body.appendChild(e));
    }
    // 2. append custom styles
    if (Array.isArray(styles)) {
      styles.forEach((value) => {
        if (value) {
          doc.head.appendChild(isValidURL(value) ? createLinkStyle(doc, value) : createStyle(doc, value));
        }
      });
    }
    // 3. append element copy
    doc.body.appendChild(this.elCopy);
    // 4. append custom scripts
    if (Array.isArray(scripts)) {
      scripts.forEach((value) => {
        if (value) {
          const script = doc.createElement("script");
          if (isValidURL(value)) {
            script.src = value;
          }
          else {
            script.innerText = value;
          }
          doc.body.appendChild(script);
        }
      });
    }
    doc.close();
  }
  /**
   * Print an URL
   *
   * @param url URL to print
   * @param callback Optional callback that will be triggered when content is ready to print
   */
  printURL(url, callback) {
    if (this.isLoading)
      return;
    this.addEvents();
    this.isLoading = true;
    this.callback = callback;
    this.iframe.src = url;
  }
  launchPrint(contentWindow) {
    const result = contentWindow.document.execCommand("print", false, undefined);
    if (!result) {
      contentWindow.print();
    }
  }
  addEvents() {
    if (!this.hasEvents) {
      this.hasEvents = true;
      this.iframe.addEventListener("load", () => this.onLoad(), false);
    }
  }
  onLoad() {
    if (this.iframe) {
      this.isLoading = false;
      const { contentDocument, contentWindow } = this.iframe;
      if (!contentDocument || !contentWindow)
        return;
      if (this.callback) {
        this.callback({
          iframe: this.iframe,
          element: this.elCopy,
          launchPrint: () => this.launchPrint(contentWindow)
        });
      }
      else {
        this.launchPrint(contentWindow);
      }
    }
  }
  static getInstance() {
    if (!Printd.instance) {
      Printd.instance = new Printd()
    }
    return Printd.instance
  }
}
export { Printd };



// WEBPACK FOOTER //
// ./src/components/common/printer.js